import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7513f702"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page-main"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "app-title"
}, "面具约会", -1));

const _hoisted_5 = ["src"];

const _hoisted_6 = /*#__PURE__*/_createTextVNode("  Android下载 ");

const _hoisted_7 = ["src"];

const _hoisted_8 = /*#__PURE__*/_createTextVNode("  苹果企业版下载 ");

const _hoisted_9 = {
  class: "tips-back"
};
const _hoisted_10 = {
  class: "tips-item"
};
const _hoisted_11 = ["src"];

const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 真人认证    职业认证 ");

const _hoisted_13 = {
  class: "tips-item"
};
const _hoisted_14 = ["src"];

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 真诚交友    遇见心动 ");

const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "tips-val"
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 点击右上角 ");

const _hoisted_19 = ["src"];

const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 选择\"浏览器中打开\"");

const _hoisted_21 = ["src"];
const _hoisted_22 = {
  key: 1,
  class: "hide_back"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $setup.down_back,
    class: "down-back"
  }, null, 8, _hoisted_2), _createElementVNode("img", {
    src: $setup.icon,
    class: "app-icon"
  }, null, 8, _hoisted_3), _hoisted_4, _createElementVNode("div", {
    class: "down-btn btn-back",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.down && $setup.down(...args))
  }, [_createElementVNode("img", {
    src: $setup.android,
    class: "down-icon"
  }, null, 8, _hoisted_5), _hoisted_6]), _createElementVNode("div", {
    class: "web-btn btn-back",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.toApple && $setup.toApple(...args))
  }, [_createElementVNode("img", {
    src: $setup.apple,
    class: "down-icon"
  }, null, 8, _hoisted_7), _hoisted_8]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    src: $setup.safe,
    class: "down-icon"
  }, null, 8, _hoisted_11), _hoisted_12]), _createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
    src: $setup.mores,
    class: "down-icon"
  }, null, 8, _hoisted_14), _hoisted_15])])]), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "share-back",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.close && $setup.close(...args))
  }, [_createElementVNode("img", {
    src: $setup.wechatjt,
    class: "wechatjt"
  }, null, 8, _hoisted_16), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", null, [_hoisted_18, _createElementVNode("img", {
    src: $setup.point,
    class: "point-img"
  }, null, 8, _hoisted_19)]), _createElementVNode("div", null, [_hoisted_20, $setup.isIos ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $setup.safari,
    class: "safari"
  }, null, 8, _hoisted_21)) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_22)) : _createCommentVNode("", true)]);
}